import { requestAxios } from 'services';
import { scheduledCollectFactory } from 'factories';
import { ScheduleCollectGroup } from 'types';

interface GetParams {
  store: string;
  codes?: string;
  deliveryMode?: string;
}

async function get(params: GetParams): Promise<ScheduleCollectGroup[]> {
  let result: ScheduleCollectGroup[] = [];

  try {
    const response = await requestAxios.get(
      'consignments/v2/scheduled-collection',
      { params }
    );

    result = response.data.data;
  } catch (error) {
    console.error(error);
  }

  return scheduledCollectFactory(result);
}

interface PostParams {
  store: string;
  codes: string;
  name: string;
  cpf: string;
  deliveryMode: string;
  digitalAssign?: string;
}

async function batchPost({
  store,
  codes,
  name,
  cpf,
  deliveryMode,
  digitalAssign,
}: PostParams): Promise<{ status?: number; errors?: any }> {
  let result: any;
  const params = {
    store,
    codes,
    name,
    cpf,
    deliveryMode,
  };

  const body = digitalAssign ? { digitalAssign: digitalAssign } : undefined;

  try {
    const response = await requestAxios.post(
      `consignments/batch-collect`,
      body,
      { params, headers: { 'Content-Type': 'application/json' } }
    );

    result = response;
  } catch (error) {
    console.error(error);
  }

  return result;
}

export const scheduledCollectServices = {
  get,
  batchPost,
};
